import { all } from 'redux-saga/effects';
import AuthSagas from 'src/modules/auth/store/authSaga';
import AppSagas from 'src/modules/app/store/appSaga';
import PublicSagas from 'src/modules/onBoarding/store/publicSaga'

function* rootSaga() {
  yield all([
    AuthSagas(),
    AppSagas(),
    PublicSagas(),
  ]);
}

export default rootSaga;

